import React from 'react'
import './BottomSection.css'
import { Link } from 'react-router-dom';

function BottomSection({address,distance,link,place}) {
  return (
    <div className="info-section">
        <h2 className='info-heading'>Find your Arrivals and Departures</h2>
        <div className="info-text"> 
          <p className='info-paragraph'>Location:</p>
          <p className='info-paragraph'>
            {address}
          </p>
          <p className='info-paragraph'>
            {distance}
          </p>
        </div> 
        { link && 
         <a target="_blank" href="https://www.spiritaircargohandling.com/locations/Denmark/Billund/Location" className="map-link">How to get there ?</a>
        }
        <div className="button-group">
           <a target="_blank" href="https://www.cph.dk/en/flight-information/departures?"> <button className="cert-button">Arrivals {place} Airport</button></a>
            <a target="_blank" href="https://www.bll.dk/en/flight-traffic/departures/"><button className="cert-button">Departures {place} Airport</button></a>
        </div>

    </div>
  )
}

export default BottomSection